export default [
  {
    id: 1,
    label: 'Massage services',
    param: 'massage',
    paramId: 2
  },
  {
    id: 2,
    label: 'Body services',
    param: 'body',
    paramId: 10
  },
  {
    id: 3,
    label: 'Facial treatment',
    param: 'facial',
    paramId: 11
  },
  {
    id: 4,
    label: 'Glamour bar',
    param: 'glamour',
    paramId: 13
  },
  {
    id: 5,
    label: 'View all',
    param: 'all',
    paramId: null
  }
];
